import type { Transactable } from '@src/domains/transactables/types/transactable';
import { isTransactablePayable } from '@src/domains/transactables/core/isTransactablePayable';
import { isTransactablePaymentComplete } from '@src/domains/transactables/core/isTransactablePaymentComplete';

// Behaviour change, not parity: the hand-written version carried the "or completed" term on the sale
// branch only, so a confirmed order read as expired and the DirectLink success screen was suppressed.
export const isTransactablePayableOrCompleted = (tr: Transactable): boolean =>
  isTransactablePayable(tr) || isTransactablePaymentComplete(tr);
